@use "ui/styles/colorsOld";
@use "ui/styles/fontsOld";

.wrapper {
    font-size: fontsOld.$medium;
    padding: 4px;
    margin: 4px;
    white-space: pre;
    height: 500px;
    overflow-y: scroll;
    resize: vertical;
    border: 1px solid colorsOld.$stoneLight;
    border-radius: 4px;

    :global {
        .string {
            color: colorsOld.$emeraldDark;
        }

        .number {
            color: colorsOld.$citrineDark;
        }

        .boolean {
            color: colorsOld.$sapphireDark;
        }

        .null {
            color: colorsOld.$rubyDark;
        }

        .key {
            color: colorsOld.$stoneDarkX1;
        }
    }
}